import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { SectionContext } from "../../context/sectionContext"
import { ErrorContext } from "../../context/errorContext"
import { fetchPincodeDetails, getChoiceMasters } from "../../../services/apiservice"
import * as lookup from "../../../../static/lookup.json"
import { JourneyContext } from "../../context/journeyContext";
import { RepeatableContext } from "../../context/repeatableContext"
import { getValueFromJourney } from "../../services/helperFunctions"
import { lineCapital } from "../../../shared/functions"
import { ConsoleView, isIE } from 'react-device-detect';

const NumberContainer = styled.div`
  display: block;
  margin: 13px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    patempDataing: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;

    & > input {
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background: var(--lumiq-bg);
    }
  }
  
`

export default function RepeatableComponentTextNumber(props) {

  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [showLocalError, setShowLocalError] = useState(false)
  const [repeatableState, setRepeatableState] = useContext(RepeatableContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext);

  const validate = target => {
    let temp
    let temp1
    if (errorState[props.data.formControlKey]) {
      temp1 = errorState[props.data.formControlKey]
    } else {
      temp1 = []
    }
    if (props.data.required) {
      //   required field validation
      if (!sectionState.sectionData[props.data.formControlKey] || !sectionState.sectionData[props.data.formControlKey][props.index]) {
        // console.log("dchdh1", props, sectionState)
        temp1[props.index] = (getValueFromJourney(
          journeyState.lookup.required_error,
          props.data.requiredError
        ))
        temp = temp1
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
        return
      }
      if ((sectionState.sectionData[props.data.formControlKey]) && (!sectionState.sectionData[props.data.formControlKey][props.index])) {
        temp1[props.index] = (getValueFromJourney(
          journeyState.lookup.required_error,
          props.data.requiredError
        ))
        temp = temp1
        setErrorState(prev => {
          // console.log("dchdh2", props, sectionState)
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      } else {
        temp1[props.index] = ""
        temp = temp1
        setErrorState(prev => {
          // console.log("dchdh3", props, sectionState)
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
      temp1[props.index] = ""
      temp = temp1
      if (target.value) {
        // console.log("dchdh4", props, sectionState)
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
    }
    if (target.value) {
      if (props.data.min_len) {
        // min_len validation
        if (target.value.length < props.data.min_len) {
          temp1[props.index] = (getValueFromJourney(
            journeyState.lookup.min_error,
            props.data.min_len_error
          ))
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
          setShowLocalError(true)
          return
        } else {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
        }
      }
      if (props.data.max_len) {
        //max length validation
        if (target.value.length > props.data.max_len) {
          temp1[props.index] = (getValueFromJourney(
            journeyState.lookup.max_error,
            props.data.max_len_error
          ))
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
          setShowLocalError(true)
          return
        } else {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp
            }
          })
        }
      }
      if (props.data.regex) {
        let regex = props.data.regex.toString()
        let rg = regex.substring(1, regex.lastIndexOf("/"))
        let flags = regex.substring(regex.lastIndexOf("/") + 1)
        let regex_exp = new RegExp(rg, flags)
        if (regex_exp.test(target.value)) {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
        } else {
          temp1[props.index] = (getValueFromJourney(
            journeyState.lookup.required_error,
            props.data.regexError
          ))
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data
                .formControlKey + props.index]: temp,
            }
          })
          setShowLocalError(true)
          return
        }
      }

    }
    if ("ifDeseased" == props.data.formControlKey) {
      let setTemp
      let changeTemp
      let familyMemberValue
      let changeFamilyMember
      let changeTempValue
      let setTempValue
      if (errorState["familyMemberDetails"]) {
        changeTempValue = errorState["familyMemberDetails"]
      } else {
        changeTempValue = []
      }
      if (errorState["causeOfDeath"]) {
        changeTemp = errorState["causeOfDeath"]
      } else {
        changeTemp = []
      }
      if (errorState["familyMemberHealthLA"]) {
        familyMemberValue = errorState["familyMemberHealthLA"]
      } else {
        familyMemberValue = []
      }
      if (target.value) {
        changeTempValue[props.index] = ""
        setTempValue = changeTempValue
        if(errorState["familyMemberDetails"]){
          setErrorState(prev => {
            return ({
              ...prev,
              ["familyMemberDetails"]: setTempValue
            })
          })
        }
        if (!sectionState.sectionData.hasOwnProperty('causeOfDeath') || sectionState.sectionData['causeOfDeath'][props.index] == undefined||sectionState.sectionData['causeOfDeath'][props.index] == "") {
          changeTemp[props.index] = "Please enter cause of death"
          setTemp = changeTemp
          console.log("hello ")
          setErrorState(prev => {
            return ({
              ...prev,
              ["causeOfDeath"]: setTemp
            })
          })
        }
        if (!sectionState.sectionData.hasOwnProperty('familyMemberHealthLA') || sectionState.sectionData['familyMemberHealthLA'][props.index] == undefined||sectionState.sectionData['familyMemberHealthLA'][props.index] == "") {
          familyMemberValue[props.index] = "Please select Family Member"
          changeFamilyMember = familyMemberValue
           setErrorState(prev => {
            return ({
              ...prev,
              ["familyMemberHealthLA"]: changeFamilyMember
            })
          })
        }
        setShowLocalError(true)
          return
      }
      else {
        if(sectionState.sectionData.hasOwnProperty('ifAlive') && sectionState.sectionData['familyMemberHealthLA'][props.index] && !sectionState.sectionData["ifAlive"][props.index]){
          changeTempValue[props.index] = "Please enter the details for Family Member"
          setTempValue = changeTempValue
        setErrorState(prev => {
          return ({
            ...prev,
            ["familyMemberDetails"]: setTempValue
          })
        })
      }
        console.log("hello iji")
        changeTemp[props.index] = ""
        setTemp = changeTemp
        familyMemberValue[props.index] = ""
        changeFamilyMember = familyMemberValue
        setErrorState(prev => {
          return ({
            ...prev,
            ["familyMemberHealthLA"]: changeFamilyMember,
            ["causeOfDeath"]: setTemp
          })
        })
        setShowLocalError(true)
        return
      }
    }
    if (props.data.formControlKey === "ifAlive") {
      let familyMemberValue
      let changeFamilyMember
      let changeTempValue
      let setTempValue
      if (errorState["familyMemberDetails"]) {
        changeTempValue = errorState["familyMemberDetails"]
      } else {
        changeTempValue = []
      }
      if (errorState["familyMemberHealthLA"]) {
        familyMemberValue = errorState["familyMemberHealthLA"]
      } else {
        familyMemberValue = []
      }
      if (target.value) {
        changeTempValue[props.index] = ""
        setTempValue = changeTempValue
        if(errorState["familyMemberDetails"]){
          setErrorState(prev => {
            return ({
              ...prev,
              ["familyMemberDetails"]: setTempValue
            })
          })
        }
        if (!sectionState.sectionData.hasOwnProperty('familyMemberHealthLA') || sectionState.sectionData['familyMemberHealthLA'][props.index] == undefined||sectionState.sectionData['familyMemberHealthLA'][props.index] == "") {
          familyMemberValue[props.index] = "Please select Family Member"
          changeFamilyMember = familyMemberValue
           setErrorState(prev => {
            return ({
              ...prev,
              ["familyMemberHealthLA"]: changeFamilyMember
            })
          })
        }
        setShowLocalError(true)
          return
      }
      else {
        if(sectionState.sectionData.hasOwnProperty('ifDeseased') && sectionState.sectionData['familyMemberHealthLA'][props.index] && !sectionState.sectionData["ifDeseased"][props.index]){
          changeTempValue[props.index] = "Please enter the details for Family Member"
          setTempValue = changeTempValue
          setErrorState(prev => {
            return ({
              ...prev,
              ["familyMemberDetails"]: setTempValue
            })
          })
        }
        familyMemberValue[props.index] = ""
        changeFamilyMember = familyMemberValue
        setErrorState(prev => {
          return ({
            ...prev,
            ["familyMemberHealthLA"]: changeFamilyMember
          })
        })
        setShowLocalError(true)
        return
      }
    }
    // console.log(errorState, "error State")

    return
  }

  const handleCheckers = (target) => {
    // For Iselect360plan
    if (props.data.formControlKey.toLowerCase().includes("pincode") && props.sectionId !== "SectionFlexiEdgeFillProposalNomineeDetails") {
      checkNegativePincode(target)
    }
    else if (props.sectionId === "nomineeDetailsSection" && props.data.formControlKey == "nomineePercent") {
      checkNomineePercentage(target)
    }
    // For CPF plan
    else if (props.data.formControlKey.toLowerCase().includes("pincode") && props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails") {
      checkNegativePincodeCPF(target)
    }

    else if (props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails" && props.data.formControlKey == "nomineePercentCPF") {
      checkNomineePercentage(target)
    }
  }

  const checkNomineePercentage = (target) => {
    // For Islect360 Plans
    if (props.sectionId === "nomineeDetailsSection" && props.data.formControlKey == "nomineePercent") {
      let values = sectionState.sectionData["nomineePercent"]
      let total
      if (!values) {
        return
      } else if (values?.length === 1) {
        total = parseInt(values[0])
      } else {
        total = values?.reduce((a, b) => {
          return parseInt(a) + parseInt(b)
        })
      }
      let temp
      let temp1
      if (errorState["nomineePercent"]) {
        temp1 = errorState["nomineePercent"]
      } else {
        temp1 = []
      }
      if (total !== 100) {
        const numberOfNominees = sectionState.sectionData["nomineePercent"].length
        for (let i = 0; i < numberOfNominees; i++) {
          temp1[i] = "Total of Nominee Percentages must be 100"
        }
        temp = temp1
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: temp,
          }
        })
        setShowLocalError(true)
      } else {
        const numberOfNominees = sectionState.sectionData["nomineePercent"].length
        for (let i = 0; i < numberOfNominees; i++) {
          temp1[i] = ""
        }
        temp = temp1
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: temp,
          }
        })
      }

    }
    
    // For CPF plans
    else if (props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails" && props.data.formControlKey == "nomineePercentCPF") {
      let values = sectionState.sectionData["nomineePercentCPF"]
      let total
      if (!values) {
        return
      } else if (values?.length === 1) {
        total = parseInt(values[0])
      } else {
        total = values?.reduce((a, b) => {
          return parseInt(a) + parseInt(b)
        })
      }
      let temp
      let temp1
      if (errorState["nomineePercentCPF"]) {
        temp1 = errorState["nomineePercentCPF"]
      } else {
        temp1 = []
      }
      if (total !== 100) {
        const numberOfNominees = sectionState.sectionData["nomineePercentCPF"].length
        for (let i = 0; i < numberOfNominees; i++) {
          temp1[i] = "Total of Nominee Percentages must be 100"
        }
        temp = temp1
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: temp,
          }
        })
        setShowLocalError(true)
      } else {
        const numberOfNominees = sectionState.sectionData["nomineePercentCPF"].length
        for (let i = 0; i < numberOfNominees; i++) {
          temp1[i] = ""
        }
        temp = temp1
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: temp,
          }
        })
      }

    }
  }

  const checkNegativePincode = (target) => {
    if (props.data.formControlKey.toLowerCase().includes("pincode") && (target.value && target.value.length === 6)) {
      let temp
      let temp1
      if (errorState[props.data.formControlKey]) {
        temp1 = errorState[props.data.formControlKey]
      } else {
        temp1 = []
      }

      //checking for incorrect pincode
      if (target.value == "000000") {
        temp1[props.index] = "This Pincode is incorrect"
        temp = temp1
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }

      // const negativePincodes = lookup["negativePincodes"]
      // let index = negativePincodes.findIndex(element => element === target.value)
      // if(index !== -1){
      //   temp1[props.index] = "This Pincode is not serviceable"
      //   temp = temp1
      //   setErrorState(prev => {
      //     return({
      //       ...prev,
      //       [props.data.formControlKey]: temp
      //     })
      //   })

      //   let tempState
      //   if (sectionState.sectionData["state"]) {
      //     let temp1 = sectionState.sectionData["state"]
      //     temp1[props.index] = ""
      //     tempState = temp1
      //   } else {
      //     let temp1 = []
      //     temp1[props.index] = ""
      //     tempState = temp1
      //   }
      //   setSectionState(prev => {
      //     return ({
      //       ...prev,
      //       sectionData: {
      //         ...prev.sectionData,
      //         ["state"]: tempState
      //       }
      //     })
      //   })

      //   setShowLocalError(true)
      //   return
      // }else{
      const asyncStateSetter = (stateFormControlKey) => {
        let payload = {
          "pincode": target.value
        }
        fetchPincodeDetails(payload)
          .then(res => {
            let temp = JSON.parse(JSON.stringify(repeatableState["nomineePersonalDetail"]))
            console.log(temp, "before")
            let nominee = JSON.parse(JSON.stringify(temp[props.index]))
            if (res && res.pincodeDetails.state) {
              console.log(journeyState);
              nominee.components[13]["disabled"] = true
            } else {
              nominee.components[13]["disabled"] = false
            }
            let tempState
            if (sectionState.sectionData[stateFormControlKey]) {
              let temp1 = sectionState.sectionData[stateFormControlKey]
              if (res && res.pincodeDetails && res.pincodeDetails.state) {
                temp1[props.index] = res?.pincodeDetails?.state;
              } else {
                temp1[props.index] = sectionState.sectionData[stateFormControlKey][props.index]
              }
              tempState = temp1
            } else {
              let temp1 = []
              if (res && res.pincodeDetails && res.pincodeDetails.state) {
                temp1[props.index] = res?.pincodeDetails?.state;
              } else {
                temp1[props.index] = ""
              }
              tempState = temp1
            }
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [stateFormControlKey]: tempState
                }
              })
            })
            temp[props.index] = nominee
            console.log(temp, "after")
            setRepeatableState(prev => {
              return ({
                ...prev,
                ["nomineePersonalDetail"]: temp
              })
            })
          })
          .catch((err) => {
            // This case executes If pincode not valid
            console.log("Please enter valid pincode", err)
            temp1[props.index] = "Please enter valid pincode"
            temp = temp1
            setErrorState(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: temp
              })
            })

            let tempState
            if (sectionState.sectionData[stateFormControlKey]) {
              let temp1 = sectionState.sectionData[stateFormControlKey]
              temp1[props.index] = ""
              tempState = temp1
            } else {
              let temp1 = []
              temp1[props.index] = ""
              tempState = temp1
            }
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [stateFormControlKey]: tempState
                }
              })
            })
            setShowLocalError(true)
            return
          })
      }
      if (props.sectionId === "nomineeDetailsSection" && props.data.formControlKey == "pincode") {
        asyncStateSetter("state")
      }
      // }
    }
  }

  const checkNegativePincodeCPF = (target) => {
    if (props.data.formControlKey.toLowerCase().includes("pincode") && (target.value && target.value.length === 6)) {
      let temp
      let temp1
      if (errorState[props.data.formControlKey]) {
        temp1 = errorState[props.data.formControlKey]
      } else {
        temp1 = []
      }

      //checking for incorrect pincode
      if (target.value == "000000") {
        temp1[props.index] = "This Pincode is incorrect"
        temp = temp1
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }

      const asyncStateSetter = (stateFormControlKey, cityFormControlKey) => {
        let payload = {
          "pincode": target.value
        }
        fetchPincodeDetails(payload)
          .then(res => {
            let temp = JSON.parse(JSON.stringify(repeatableState["proposalFormNomineeDetails"]))
            console.log(temp, "before")
            let nominee = JSON.parse(JSON.stringify(temp[props.index]))
            //For State
            if (res && res.pincodeDetails?.state) {
              console.log(journeyState);
              nominee.components[14]["disabled"] = true
            } else {
              nominee.components[14]["disabled"] = false
            }
            //For City
            if(res && res.pincodeDetails?.city){
              nominee.components[15]["disabled"] = true
            }else {
              nominee.components[15]["disabled"] = false
            }
            let tempState
            if (sectionState.sectionData[stateFormControlKey]) {
              let temp1 = sectionState.sectionData[stateFormControlKey]
              if (res && res.pincodeDetails && res.pincodeDetails.state) {
                temp1[props.index] = res?.pincodeDetails?.state;
              } else {
                temp1[props.index] = sectionState.sectionData[stateFormControlKey][props.index]
              }
              tempState = temp1
            } else {
              let temp1 = []
              if (res && res.pincodeDetails && res.pincodeDetails.state) {
                temp1[props.index] = res?.pincodeDetails?.state;
              } else {
                temp1[props.index] = ""
              }
              tempState = temp1
            }

            let tempCity
            if (sectionState.sectionData[cityFormControlKey]) {
              let temp1 = sectionState.sectionData[cityFormControlKey]
              if (res && res.pincodeDetails && res.pincodeDetails.city) {
                temp1[props.index] = res?.pincodeDetails?.city?.toUpperCase();
              } else {
                temp1[props.index] = sectionState.sectionData[cityFormControlKey][props.index]
              }
              tempCity = temp1
            } else {
              let temp1 = []
              if (res && res.pincodeDetails && res.pincodeDetails.city) {
                temp1[props.index] = res?.pincodeDetails?.city?.toUpperCase();
              } else {
                temp1[props.index] = ""
              }
              tempCity = temp1
            }
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [stateFormControlKey]: tempState,
                  [cityFormControlKey]: tempCity
                }
              })
            })
            temp[props.index] = nominee
            console.log(temp, "after")
            setRepeatableState(prev => {
              return ({
                ...prev,
                ["proposalFormNomineeDetails"]: temp
              })
            })
          })
          .catch((err) => {
            // This case executes If pincode not valid
            console.log("Please enter valid pincode", err)
            temp1[props.index] = "Please enter valid pincode"
            temp = temp1
            setErrorState(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: temp
              })
            })

            let tempState
            if (sectionState.sectionData[stateFormControlKey]) {
              let temp1 = sectionState.sectionData[stateFormControlKey]
              temp1[props.index] = ""
              tempState = temp1
            } else {
              let temp1 = []
              temp1[props.index] = ""
              tempState = temp1
            }

            let tempCity
            if (sectionState.sectionData[cityFormControlKey]) {
              let temp1 = sectionState.sectionData[cityFormControlKey]
              temp1[props.index] = ""
              tempCity = temp1
            } else {
              let temp1 = []
              temp1[props.index] = ""
              tempCity = temp1
            }
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [stateFormControlKey]: tempState,
                  [cityFormControlKey]: tempCity
                }
              })
            })
            setShowLocalError(true)
            return
          })
      }
      if (props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails" && props.data.formControlKey == "nomineePincode") {
        asyncStateSetter("stateNominee", "cityNominee")
      }
      // }
    }
  }


  useEffect(() => {
    validate({
      value: (sectionState.sectionData[props.data.formControlKey] ? sectionState.sectionData[props.data.formControlKey][props.index] ?? "" : "")
    })
  }, [sectionState.sectionData[props.data.formControlKey]?.[props.index]])

  const updateSectionState = (val, change) => {
    setSectionState((prev) => {
      return (
        {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [val]: change
          }
        }
      )
    })
  }

  const handleChange = ({ target }) => {

    if (!isNaN(target.value)) {

      if (sectionState.sectionId === props.sectionId) {
        let temp
        if (sectionState.sectionData[props.data.formControlKey]) {
          let temp1 = sectionState.sectionData[props.data.formControlKey]
          temp1[props.index] = target.value;
          temp = temp1
        } else {
          let temp1 = []
          temp1[props.index] = target.value
          temp = temp1
        }
        if (repeatableState.familyMemberHealthLA && props.sectionId === "SectionFlexiEdgeFillProposalMedicalInformation") {

          let tempData = JSON.parse(JSON.stringify(repeatableState.familyMemberHealthLA))
          let setTemp = JSON.parse(JSON.stringify(tempData[props.index]))
          if ("ifAlive" === props.data.formControlKey) {
            if (sectionState.sectionData.hasOwnProperty('causeOfDeath') || sectionState.sectionData.hasOwnProperty('ifDeseased')) {
              if (sectionState.sectionData.hasOwnProperty('causeOfDeath') && sectionState.sectionData["causeOfDeath"][props.index]) {
                let temp1 = sectionState.sectionData["causeOfDeath"]
                temp1[props.index] = '';
                let change = temp1
                updateSectionState("causeOfDeath", change)
              } if (sectionState.sectionData.hasOwnProperty('ifDeseased') && sectionState.sectionData["ifDeseased"][props.index]) {
                let temp1 = sectionState.sectionData["ifDeseased"]
                temp1[props.index] = '';
                let change = temp1
                updateSectionState("ifDeseased", change)
              }
            }
            setTemp.components.find(op => op.formControlKey == "ifDeseased").disabled = target.value ? true : false
            setTemp.components.find(op => op.formControlKey == "causeOfDeath").disabled = target.value ? true : false
            setTemp.components.find(op => op.formControlKey == "familyMemberHealthLA").required = target.value ? true : false
          }
          if ("ifDeseased" === props.data.formControlKey || "causeOfDeath" === props.data.formControlKey) {
            if (sectionState.sectionData.hasOwnProperty('ifAliveDisease') || sectionState.sectionData.hasOwnProperty('ifAlive')) {
              if (sectionState.sectionData.hasOwnProperty('ifAliveDisease') && sectionState.sectionData["ifAliveDisease"][props.index]) {
                let temp1 = sectionState.sectionData["ifAliveDisease"]
                temp1[props.index] = '';
                let change = temp1
                updateSectionState("ifAliveDisease", change)
              } if (sectionState.sectionData.hasOwnProperty('ifAlive') && sectionState.sectionData["ifAlive"][props.index]) {
                let temp1 = sectionState.sectionData["ifAlive"]
                temp1[props.index] = '';
                let change = temp1
                updateSectionState("ifAlive", change)
              }
            }
            setTemp.components.find(op => op.formControlKey == "ifAlive").disabled = target.value ? true : false
            setTemp.components.find(op => op.formControlKey == "ifAliveDisease").disabled = target.value ? true : false
          }
          tempData[props.index] = setTemp
          setRepeatableState(prev => {
            return ({
              ...prev,
              ["familyMemberHealthLA"]: tempData
            })
          })
        }
        setSectionState((prev) => {
          return (
            {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: temp
              }
            }
          )
        })
      } else {
        setSectionState((prev) => {
          let temp
          if (sectionState.sectionData[props.data.formControlKey]) {
            let temp1 = sectionState.sectionData[props.data.formControlKey]
            temp1[props.index] = target.value;
            temp = temp1
          } else {
            let temp1 = []
            temp1[props.index] = target.value
            temp = temp1
          }
          return (
            {
              ...prev,
              sectionId: props.sectionId,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: temp
              }
            }
          )
        })
      }
      validate(target)
    }
    //console.log(sectionState, "section state")
  }
  return (
    <>
      <style>{
        `input[type=number]::-webkit-inner-spin-button, 
      input[type=number]::-webkit-outer-spin-button { 
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          margin: 0; 
      }`
      }
      </style>
      <NumberContainer channel={props.channel} className={`form-group input-container ${props.data.disabled ? 'disable-input' : ''}`} >
        <label htmlFor={props.data.label} className={`input-label ${props.data.label ? '' : "no-label"} `} >{(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}</label>
        <input
          className={`form-control ${isIE ? 'IELineHeight' : ''}`}
          type={props.data.type}
          name={+Date.now()}
          placeholder={(getValueFromJourney(
            journeyState.lookup.placeholder,
            props.data.placeholder
          )) || props.data.placeholder}
          required={props.data.required}
          disabled={props.data.disabled}
          autoComplete="new-password"
          onChange={handleChange}
          value={(sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey][props.index]) ? sectionState.sectionData[props.data.formControlKey][props.index] : ""}
          onBlur={(e) => handleCheckers(e.target)}
          maxLength={props.data.max_len}
        ></input>
        <span className="input-error2">
          {(props.showError || showLocalError) && (
            Array.isArray(errorState?.[props.data.formControlKey])
              ? errorState?.[props.data.formControlKey]?.[props.index]
              : errorState?.[props.data.formControlKey]
          )
          }
        </span>
      </NumberContainer>

    </>
  )
}
